import { useNavigate } from "react-router-dom";
import { getProfessionalById } from "../../../service/MainService";

const RelatedCollaborators = ({ projectDetails }) => {
  const navigate = useNavigate();
  const collaborationColors = {
    Architects: "#222223",
    Engineers: "#FDBA74",
    Builder: "#AB3428",
    Team: "#4F86C6",
    Products: "#A6A15E",
  };

  const navigateToProfessionalDetail = async (userId, event) => {
    try {
      event.preventDefault();

      const token = localStorage.getItem("accessToken");
      const userDetails = await getProfessionalById(userId, token);

      navigate(`/professionals/${userId}`, {
        state: { userDetails },
      });
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  return (
    <>
      {projectDetails.Collaborators.length > 0 && (
        <div className="mb-10 mt-10">
          <div className="flex flex-col md:flex-row items-center">
            <div className="text-xl md:pr-4 mb-4 md:mb-0 font-semibold">
              Collaborators
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mt-5">
            {projectDetails.Collaborators.map((collab, index) => (
              <div
                className="flex flex-col items-center gap-2 justify-center py-5"
                key={index}
              >
                <img
                  src={collab.profilePicture}
                  alt="avatar"
                  className="h-[8rem] w-[8rem] rounded-full border-4"
                  style={{
                    borderColor:
                      collaborationColors[collab.collaborationTypes] || "",
                  }}
                />
                <h1>{collab.collaboratorName}</h1>
                <button
                  class="text-white bg-gray-800 hover:bg-neutral-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium text-sm px-3 py-1.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  onClick={(event) =>
                    navigateToProfessionalDetail(collab.collabaraotorId, event)
                  }
                >
                  View Profile
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RelatedCollaborators;
